import {
    Element,
    Icon,
    Image,
    RouterLink,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IContent, IMatch, ITournament } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils, ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { getDateInText, unixToDate } from '@zmedia/bm-soccer-ui/utils/date';
import ContentList from '@zmedia/bm-soccer-ui/modules/content/components/list';
import { Table, TableGroup } from '../../views/ranking/components';
import { Score, Team } from '@zmedia/bm-soccer-ui/modules/match';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';
import { ITransfer } from '@zmedia/bm-soccer-ui/interface/transfer';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { TransferSlider } from '@zmedia/bm-soccer-ui/modules/transfer';
import { RankingSidebar } from '@zmedia/bm-soccer-ui/layout/sidebar/right/RankingSidebar';

import styles from './style.module.scss';

interface IProps {
    contents: IContent[];
    itemSizeLimit: number;
    tournament: ITournament;
    standing?: any;
    matches: IMatch[];
    transfers?: ITransfer[];
    listProps?: any;
}
function TournamentSection({
    contents = [],
    itemSizeLimit = 5,
    tournament,
    standing = {},
    matches = [],
    transfers = [],
    listProps,
}: IProps) {
    return (
        <Element className={styles['tournament-section']}>
            <Title renderAs="h2">
                <RouterLink
                    to={`${URL_SOCCER_PAGE.SUBPATH}${tournament.path}`}
                    title={tournament.name}
                >
                    <Image
                        src={tournament.logo}
                        alt={'Giải đấu ' + tournament.name}
                    />
                    <span>{tournament.name}</span>
                    <Icon icon="forward-2" />
                </RouterLink>
            </Title>
            <Element className={styles['section-container']}>
                <ContentList
                    items={contents.slice(0, 3)}
                    ContentItemClass={{
                        CardHeaderClass: '!text-[1.8rem]',
                    }}
                    {...listProps}
                />
                <TransferSlider transfers={transfers} tournament={tournament} />
                {!ArrayUtils.isEmpty(matches) && (
                    <Element className={styles['tournament-matches']}>
                        <TitleWrap
                            title="Lịch thi đấu"
                            link={`${URL_SOCCER_PAGE.SUBPATH}lich-thi-dau-${tournament.path}`}
                        >
                            <Icon icon="forward-2" />
                        </TitleWrap>
                        <Element className={styles['tournament-match-list']}>
                            {matches.map((item, index) => {
                                return (
                                    <Element
                                        className={styles['match-item']}
                                        key={index}
                                    >
                                        <RouterLink
                                            to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                                            title={
                                                item.home.team.name +
                                                ' đấu với ' +
                                                item.away.team.name
                                            }
                                        >
                                            <Team team={item.home.team} />
                                            <Element
                                                className={styles['match-info']}
                                            >
                                                {getDateInText(
                                                    unixToDate(
                                                        item.startTime,
                                                        'YYYY-MM-DD'
                                                    ),
                                                    'DD/MM/YYYY'
                                                )}
                                                <Score item={item}></Score>
                                            </Element>
                                            <Team team={item.away.team} />
                                        </RouterLink>
                                    </Element>
                                );
                            })}
                        </Element>
                    </Element>
                )}

                {!ObjectUtils.isEmpty(standing) && (
                    <RankingSidebar>
                        <TitleWrap
                            title="Bảng xếp hạng"
                            link={`${URL_SOCCER_PAGE.SUBPATH}bang-xep-hang-${tournament.path}`}
                        >
                            <Icon icon="forward-2" />
                        </TitleWrap>
                        {standing.groups?.length > 0 ? (
                            <TableGroup {...standing} selectMode>
                                <RouterLink
                                    className={styles['view-more']}
                                    to={`${URL_SOCCER_PAGE.SUBPATH}bang-xep-hang-${tournament.path}`}
                                    title="Xem chi tiết"
                                >
                                    Xem chi tiết
                                </RouterLink>
                            </TableGroup>
                        ) : (
                            <Table {...standing} itemSizeLimit={itemSizeLimit}>
                                <RouterLink
                                    className={styles['view-more']}
                                    to={`${URL_SOCCER_PAGE.SUBPATH}bang-xep-hang-${tournament.path}`}
                                    title="Xem chi tiết"
                                >
                                    Xem chi tiết
                                </RouterLink>
                            </Table>
                        )}
                    </RankingSidebar>
                )}
            </Element>
        </Element>
    );
}

export default memo(TournamentSection);
